import { create } from 'zustand';
import _debounce from 'lodash/debounce';

type PublicNoticesView = 'table' | 'map';

interface PublicNoticesState {
  apiValidationErrors: string[];
  debouncedSearchText: string;
  districtCodes: string[];
  searchText: string;
  stateCodes: string[];
  view: PublicNoticesView;

  clearApiValidationErrors: () => void;
  resetToDefaults: () => void;
  setApiValidationErrors: (apiValidationErrors: string[]) => void;
  setDistrictCodes: (districtCodes: string[]) => void;
  setSearchText: (searchText: string) => void;
  setStateCodes: (stateCodes: string[]) => void;
  setView: (view: PublicNoticesView) => void;
}

const setDebouncedSearchText = _debounce((set, searchText: string) => {
  set({ debouncedSearchText: searchText });
}, 500);

export const usePublicNotices = create<PublicNoticesState>((set) => {
  const defaults: PublicNoticesState = {
    apiValidationErrors: [],
    debouncedSearchText: '',
    districtCodes: [],
    searchText: '',
    stateCodes: [],
    view: 'table',

    clearApiValidationErrors: () => set({ apiValidationErrors: [] }),
    resetToDefaults: () => set(defaults),
    setApiValidationErrors: (apiValidationErrors: string[]) => set({ apiValidationErrors }),
    setDistrictCodes: (districtCodes: string[]) => set({ districtCodes }),
    setSearchText: (searchText: string) => {
      setDebouncedSearchText(set, searchText);
      set({ searchText });
    },
    setStateCodes: (stateCodes: string[]) => set({ stateCodes }),
    setView: (view: PublicNoticesView) => set({ view }),
  };
  return defaults;
});
